Vue.component("TkSlider", {

    props: ["elements", "startindex"],

    data() {
        return {
            currentIndex: parseInt(this.startindex) || 0,
            direction: 'right',
            animations: {
                right: {
                    enter: 'animated slideInLeft transition-duration-short',
                    leave: 'animated slideOutRight transition-duration-short',
                },
                left: {
                    enter: 'animated slideInRight transition-duration-short',
                    leave: 'animated slideOutLeft transition-duration-short',
                },
            }
        }
    },

    template: `
        <div class="tk-slider" >
            <div class="tk-slider__slide_container">
                <transition
                    name="slide"
                    :enter-active-class="animations[direction].enter"
                    :leave-active-class="animations[direction].leave">

                    <div class="tk-slider__slide_container__slide" v-for="(item, index) in elements" :key="index" v-if="index===currentIndex">
                        <slot v-bind:cfg="item"></slot>
                    </div>
                </transition>
            </div>

            <div class="tk-slider__pagination" v-if="hasMultipleSlides">
                <div @click="prev()" class="tk-slider__controls__prev" :class="getPrevClass"></div>
                <div class="tk-slider__pagination__item" v-for="(o, i) in elements" :key="i" :class="{'current': i === currentIndex}" @click="goto(i)"></div>
                <div @click="next()" class="tk-slider__controls__next" :class="getNextClass"></div>
            </div>
        </div>
    `,


    mounted() {
        const hammertime = new Hammer(this.$el, {});
        this.hammertime = hammertime;
        hammertime.on("swipeleft", () => {
            this.next();
        });
        hammertime.on("swiperight", () => {
            this.prev();
        });
    },

    destroy() {
        this.hammertime.destroy();
    },

    computed: {
        getPrevClass() {
            return this.hasPrev ? 'has-prev' : 'has-not-prev';
        },
        getNextClass() {
            return this.hasNext ? 'has-next' : 'has-not-next';
        },
        hasPrev() {
            return (this.currentIndex - 1 >= 0)
        },
        hasNext() {
            return this.currentIndex + 1 < this.elements.length;
        },
        hasMultipleSlides() {
            return this.elements.length > 1
        }
    },

    methods: {
        next() {
            this.direction = 'left';
            if (this.currentIndex + 1 < this.elements.length) {
                this.currentIndex += 1;
            }
        },
        prev() {
            this.direction = 'right';
            if (this.currentIndex - 1 >= 0) {
                this.currentIndex -= 1;
            }
        },
        goto(index) {
            this.direction = index > this.currentIndex ? "left" : "right";
            this.currentIndex = index;
        }
    }
})